
		import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "dreamland/jsx-runtime";
export const title = "Proxying on the Edge: Part 1";
export const tags = ["Devlog", "Web Proxies"];
export const description = "Part 1 of a series about running web proxies using Cloudflare Workers (Superposition).";
function _createMdxContent(props) {
  const _components = {
    a: "a",
    blockquote: "blockquote",
    code: "code",
    h2: "h2",
    p: "p",
    strong: "strong",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsxs(_components.blockquote, {
      children: ["\n", _jsx(_components.p, {
        children: "This post is a part of an ongoing series on running web proxies using Cloudflare Workers."
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["Recently, I made a proxy called ", _jsx(_components.a, {
        href: "https://superposition.bomberfish.ca",
        children: "Superposition"
      }), ", running on Cloudflare's Workers serverless platform."]
    }), "\n", _jsxs(_components.p, {
      children: ["You can check out its source code ", _jsx(_components.a, {
        href: "https://github.com/BomberFish/Superposition",
        children: "here"
      }), "."]
    }), "\n", _jsx(_components.h2, {
      children: "How?"
    }), "\n", _jsxs(_components.p, {
      children: ["It turns out there's already a project for proxying requests using CF Workers, called ", _jsx(_components.a, {
        href: "https://github.com/aD4wn/Workers-Proxy",
        children: "Workers-Proxy"
      }), ". It works by making a request to a fixed URL, then returning the response to the user. The only issue is that it only works with a single domain, which is hard-coded into the program."]
    }), "\n", _jsxs(_components.p, {
      children: ["Superposition fixes this issue by checking for a ", _jsx(_components.code, {
        children: "?url="
      }), " parameter in the requested URL. If the parameter is present, it proxies the provided URL. If not, it returns a landing page for you to input a URL."]
    }), "\n", _jsx(_components.p, {
      children: "Another feature of Superposition is that when it proxies a website, it also injects a button fixed to the top-left of the screen to go back to the landing page."
    }), "\n", _jsx(_components.h2, {
      children: "Why?"
    }), "\n", _jsx(_components.p, {
      children: "The idea was simple: Since existing proxy websites rely on a central server which may or may not be close to the user, why not use an established global network such as Cloudflare to proxy the requests?"
    }), "\n", _jsx(_components.h2, {
      children: "What next?"
    }), "\n", _jsxs(_components.p, {
      children: ["I am currently working on a new proxy, dubbed ", _jsx(_components.strong, {
        children: "Infrared"
      }), ", which is completely compliant with the ", _jsx(_components.a, {
        href: "https://tomp.app",
        children: "TompHTTP"
      }), " specifications. Infrared aims to be more stable than Superposition, and includes more advanced features such as WebSocket proxying."]
    })]
  });
}
export function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}


		export default function Page() {
			const {wrapper: MDXLayout} = this.components || ({});
			return (
				MDXLayout 
					? _jsx(MDXLayout, { children: [_createMdxContent(this)], ...this })
					: _createMdxContent(this)
			)
		}
	